import forEach from 'lodash/forEach';
import sortedUniq from 'lodash/sortedUniq';
import { ALL_COUNTRIES_LIST, CountryData, UserDTO, WIRUser } from 'types/wellGuardian';

export const countryListCheck = (wirUsers: WIRUser[], user: UserDTO | null) => {
  const captureUser = wirUsers?.filter(x => x.emailAddress === user?.email);
  const selectedCountryList: CountryData[] = [];

  const sortedUsers = [...captureUser].sort((a: WIRUser, b: WIRUser) => {
    if (a?.country && b?.country) {
      return (
        ALL_COUNTRIES_LIST?.data?.indexOf(a?.country) -
        ALL_COUNTRIES_LIST?.data?.indexOf(b?.country)
      );
    }

    return 1;
  });

  forEach(sortedUsers, x => {
    if (x.country) {
      selectedCountryList.push(x.country);
    }
  });

  return sortedUniq(selectedCountryList);
};

export const getNextCountry = (countryList: string[], countryCode: string | null) => {
  if (countryCode && countryList.includes(countryCode)) {
    return countryCode;
  }

  return countryList[0];
};
